"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectItemType = void 0;
var ProjectItemType;
(function (ProjectItemType) {
    ProjectItemType["Issue"] = "issue";
    ProjectItemType["Email"] = "email";
    ProjectItemType["Rfi"] = "rfi";
    ProjectItemType["Submittal"] = "submittal";
    ProjectItemType["File"] = "file";
    ProjectItemType["ChangeItem"] = "changeItem";
})(ProjectItemType = exports.ProjectItemType || (exports.ProjectItemType = {}));
//# sourceMappingURL=ProjectItemType.js.map